<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('house_keeping') + (hotel.name ? ' - ' + hotel.name : '')">
            <app-default-button
                :title="$fieldTitle('add', 'house_keeping', true)"
                v-if="$can('create_hotel_house_keeping')"
                @click="isFormActive = true"
            />
            <a :href="urlGenerator('/hotel/house-keeping/import')" v-if="$can('import_hotel_house_keeping')"
               class="btn btn-success btn-with-shadow ml-1">
                {{ $t('import') }}
            </a>
            <button type="button" class="btn btn-danger btn-with-shadow ml-1" @click="isBulkActive = true">
                {{ $t('update_price') }}
            </button>
        </app-page-top-section>

        <app-table
            id="house-keeping-table"
            :options="options"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-house-keeping-form
            v-if="isFormActive"
            v-model="isFormActive"
            :hotel="hotel"
        />

        <app-hotel-house-keeping-bulk
            v-if="isBulkActive"
            v-model="isBulkActive"
            :selected-url="selectedUrl"
            :hotel="hotel"
            @close="isBulkActive = false"
        />

        <app-hotel-house-keeping-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            :hotel="hotel"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('house-keeping-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<style>
.datatable [table-id="house-keeping-table"] > .avatar-group {
    display : flex;
}
</style>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelHouseKeepingMixins from "../../../Mixins/HotelHouseKeepingMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "AppHotelHouseKeeping",
    mixins: [HelperMixin, HotelHouseKeepingMixins],
    props : {
        hotel: {},
    },
    data() {
        return {
            TENANT_BASE_URL,
            isModalTypeActive: false,
            isBulkActive     : false,
            isFormActive     : false,
            isModalActive    : false,
            selectedUrl      : '',
        }
    },
    methods: {
        urlGenerator,
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/house-keeping/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
    }
}
</script>
